import { useEffect } from 'react';

import googleTagManagerService from 'static/script/app/ui/google-tagmanager-service';

/**
 * Register a new page load in GTM service once on render
 */
export const useGoogleTagManagerNewPage = () => {
    useEffect(() => {
        googleTagManagerService.newPage();
    }, []);
};
